/** Select layout: label above, full-width medium dropdown. */
export function withCompactSelectFields(fields) {
  return fields.map((field) => {
    if (field.type === 'enum' || field.type === 'multiEnum') {
      return {
        ...field,
        labelAbove: field.labelAbove ?? true,
        inputSize: field.inputSize ?? 'medium',
        selectSx: {
          minWidth: '100%',
          minHeight: 48,
          ...field.selectSx,
        },
      };
    }
    return field;
  });
}
